import React from "react";
import {
  Button,
  Menu,
  MenuPopover,
  MenuTrigger,
  Tree,
  TreeItem,
  TreeItemLayout,
  makeStyles,
  shorthands,
} from "@fluentui/react-components";
import { ChevronDownIcon } from "@fluentui/react-icons-mdl2";
import { Category, Report } from "../../../types/reportTypes";

const useStyles = makeStyles({
  accordionContainer: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
  },
});

interface ReportSelectorProps {
  categories: Category[];
  selectedReport: Report | null;
  onSelectReport: (report: Report) => void;
}

const ReportSelector: React.FC<ReportSelectorProps> = ({
  categories,
  selectedReport,
  onSelectReport,
}) => {
  const styles = useStyles();

  function renderTreeItems(nodes: any, handleSelectReport: any) {
    return nodes.map((node: any) => {
      const hasChildren =
        Array.isArray(node.children) && node.children.length > 0;
      const isReport = !!node.ReportCode;

      if (hasChildren) {
        return (
          <TreeItem itemType="branch" key={node.CategoryCode || node.Name}>
            <TreeItemLayout>{node.Name}</TreeItemLayout>
            <Tree>{renderTreeItems(node.children, handleSelectReport)}</Tree>
          </TreeItem>
        );
      }

      if (isReport) {
        return (
          <TreeItem
            itemType="leaf"
            key={node.ReportCode}
            onClick={() => handleSelectReport(node)}
          >
            <TreeItemLayout>{node.Name}</TreeItemLayout>
          </TreeItem>
        );
      }

      return null;
    });
  }

  return (
    <Menu>
      <MenuTrigger disableButtonEnhancement>
        <Button
          appearance="outline"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            minWidth: "300px",
            maxWidth: "fit-content",
          }}
        >
          {selectedReport ? selectedReport.Name : "Select a report"}
          <ChevronDownIcon style={{ marginLeft: "8px" }} />
        </Button>
      </MenuTrigger>
      <MenuPopover style={{ width: 400, maxHeight: "50vh" }}>
        <div className={styles.accordionContainer}>
          <Tree aria-label="Report Tree">
            {renderTreeItems(categories, onSelectReport)}
          </Tree>
        </div>
      </MenuPopover>
    </Menu>
  );
};

export default ReportSelector;
